import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";

const languages = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "pl", label: "Polski", short: "PL" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const currentCode = (i18n.language || "en").split("-")[0];
  const current = languages.find((l) => l.code === currentCode) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-md border border-background-300 px-3 py-2 text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <i className="ri-global-line text-base"></i>
        <span>{current.short}</span>
        <i className={`ri-arrow-down-s-line text-sm transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 rounded-lg border border-background-200 bg-background-50 py-1 animate-fade-in" role="listbox">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              role="option"
              aria-selected={l.code === currentCode}
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between px-4 py-2 text-sm cursor-pointer transition-colors hover:bg-background-100 ${
                l.code === currentCode ? "text-primary-600 font-semibold" : "text-foreground-700"
              }`}
            >
              <span>{l.label}</span>
              {l.code === currentCode && <i className="ri-check-line"></i>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}